// extracted by mini-css-extract-plugin
export var createUserProgressBar = "create-user-progress-bar_RozZyc6EOKyZgiqWg1SD";